import { TestAuthProvider } from '../test-auth-provider';
import { EAuthProviderType, type IAuthAdapter } from './types';

/**
 * Key reported by the E2E adapter. Deliberately not a usable provider key, so
 * it can never collide with a configured `authProviders` entry.
 */
export const E2E_PROVIDER_KEY = 'e2e';

/**
 * Builds the adapter that mounts the E2E identity stub.
 *
 * `auth-provider.tsx` mounts `TestAuthProvider` directly, so this exists to
 * keep {@link selectAuthAdapter}'s E2E short-circuit returning the same thing
 * the caller does rather than a real provider's adapter.
 *
 * @returns {IAuthAdapter} Adapter backed by the E2E identity stub
 */
export const createE2EAuthAdapter = (): IAuthAdapter => ({
  key: E2E_PROVIDER_KEY,
  type: EAuthProviderType.E2E,
  Provider: TestAuthProvider,
  validateConfig: () => true,
});
